// extracted by mini-css-extract-plugin
export default {"cart-items":"Cart_cart-items__XsCOI","total":"Cart_total__vRIEy","actions":"Cart_actions__XfVSz","button--alt":"Cart_button--alt__CK45k","button":"Cart_button__wsjni"};